__turbopack_context__.v({
  "actions": "ProductCard-module__J52DPa__actions",
  "addToCartButton": "ProductCard-module__J52DPa__addToCartButton",
  "badge": "ProductCard-module__J52DPa__badge",
  "card": "ProductCard-module__J52DPa__card",
  "category": "ProductCard-module__J52DPa__category",
  "details": "ProductCard-module__J52DPa__details",
  "image": "ProductCard-module__J52DPa__image",
  "link": "ProductCard-module__J52DPa__link",
  "lowestPrice": "ProductCard-module__J52DPa__lowestPrice",
  "name": "ProductCard-module__J52DPa__name",
  "price": "ProductCard-module__J52DPa__price",
  "priceBefore": "ProductCard-module__J52DPa__priceBefore",
  "pricePromo": "ProductCard-module__J52DPa__pricePromo",
  "priceWrap": "ProductCard-module__J52DPa__priceWrap",
  "status": "ProductCard-module__J52DPa__status",
});
